// extracted by mini-css-extract-plugin
export default {"content":"NewQuestion_content__U-4Zz"};